export const CONCESSION_TYPE_CUSTOM = 'custom';
export const CONCESSION_TYPE_RENT_FREE = 'rentFree';
export const CONCESSION_TYPE_RENT_DISCOUNT = 'rentDiscount';

export const CONCESSION_TYPES = [
  CONCESSION_TYPE_CUSTOM,
  CONCESSION_TYPE_RENT_FREE,
  CONCESSION_TYPE_RENT_DISCOUNT,
];

export const CONCESSION_SCHEDULE_TYPE_FIRST_MONTH = 'firstMonth';
export const CONCESSION_SCHEDULE_TYPE_SECOND_MONTH = 'secondMonth';
export const CONCESSION_SCHEDULE_TYPE_THIRD_MONTH = 'thirdMonth';
export const CONCESSION_SCHEDULE_TYPE_PRORATED = 'prorated';

export const CONCESSION_SCHEDULE_TYPES = [
  CONCESSION_SCHEDULE_TYPE_FIRST_MONTH,
  CONCESSION_SCHEDULE_TYPE_SECOND_MONTH,
  CONCESSION_SCHEDULE_TYPE_THIRD_MONTH,
  CONCESSION_SCHEDULE_TYPE_PRORATED,
];

export const CONCESSION_SCHEDULE_TYPES_TO_LABELS = {
  [CONCESSION_SCHEDULE_TYPE_FIRST_MONTH]: 'First Month',
  [CONCESSION_SCHEDULE_TYPE_SECOND_MONTH]: 'Second Month',
  [CONCESSION_SCHEDULE_TYPE_THIRD_MONTH]: 'Third Month',
  [CONCESSION_SCHEDULE_TYPE_PRORATED]: 'Prorated',
};

export const CONCESSION_DESCRIPTION_VARIATION_BANNER = 'banner';
export const CONCESSION_DESCRIPTION_VARIATION_RENTLINX = 'rentlinx';
export const CONCESSION_DESCRIPTION_VARIATION_HOUSEHOLD_NOTE = 'householdNote';
export const CONCESSION_DESCRIPTION_VARIATION_PARTNER_APPROVAL = 'partnerApproval';
export const CONCESSION_DESCRIPTION_VARIATION_LEASE_DRAFT = 'leaseDraft';

export const CONCESSION_STATUS_NOT_STARTED = 'notStarted';
export const CONCESSION_STATUS_ACTIVE = 'active';
export const CONCESSION_STATUS_ENDING_SOON = 'endingSoon';
export const CONCESSION_STATUS_EXPIRED = 'expired';
